var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 58,
    viewBox: "0 0 48 58",
    fill: "none",
    strokeWidth: 4,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 27.6668L21.3337 33.0001L33.3337 21.0001M45.3337 29.0001C45.3337 42.0893 31.0564 51.6092 25.8616 54.6398C25.2713 54.9842 24.9761 55.1564 24.5595 55.2457C24.2362 55.3151 23.7645 55.3151 23.4412 55.2457C23.0246 55.1564 22.7294 54.9842 22.139 54.6398C16.9442 51.6092 2.66699 42.0893 2.66699 29.0001V16.247C2.66699 14.115 2.66699 13.049 3.01569 12.1326C3.32372 11.3231 3.82428 10.6008 4.47408 10.0282C5.20965 9.37994 6.20779 9.00564 8.20407 8.25703L22.5022 2.89523C23.0566 2.68734 23.3338 2.58339 23.6189 2.54218C23.8719 2.50563 24.1288 2.50563 24.3817 2.54218C24.6669 2.58339 24.9441 2.68734 25.4984 2.89523L39.7966 8.25703C41.7929 9.00564 42.791 9.37994 43.5266 10.0282C44.1764 10.6008 44.6769 11.3231 44.985 12.1326C45.3337 13.049 45.3337 14.115 45.3337 16.247V29.0001Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicy);
export default __webpack_public_path__ + "static/media/policy.4bc93b2662d1d18a59ff24c7c54d9d79.svg";
export { ForwardRef as ReactComponent };